import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { BiSolidBookOpen, BiSolidInfoCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

export const SubmenuTahfidzPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Lembaga Tahfidz",
    });
  }, [setHeader]);
  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.HOME_PROFILE)}
            className="tw-flex flex tw-justify-between tw-m-0"
          >
            <BiSolidBookOpen
              className="card-icon"
              style={{
                color: "#a8ce47",
                background: "#f7fbed",
              }}
            />
            <div className="card-name">Tazmi Juz'iyah</div>
          </div>
        </div>
        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.FINANCE_BILLING_INFO)}
            className="tw-flex flex tw-justify-between tw-m-0"
          >
            <BiSolidInfoCircle
              className="card-icon"
              style={{
                color: "#a8ce47",
                background: "#f7fbed",
              }}
            />
            <div className="card-name">Ziyadah Santri</div>
          </div>
        </div>
      </div>
    </div>
  );
};
